import React from 'react';
import { SearchContent } from './SearchContent';
import { SearchContextProvider } from './SearchContext';
import { SearchProps } from './types';

const Search: React.FC<SearchProps> = ({
  codTela,
  newData,
  orderModulo,
  onRowClick,
  onlyReport,
  orderTelas = false,
  customButtons,
  customButtonPosition = 'right',
  extraColumn = undefined,
}) => {
  return (
    <SearchContextProvider
      codTela={codTela}
      newData={newData}
      orderModulo={orderModulo}
      onRowClick={onRowClick}
      onlyReport={onlyReport}
      orderTelas={orderTelas}
      customButtons={customButtons}
      customButtonPosition={customButtonPosition}
      extraColumn={extraColumn}
    >
      <SearchContent />
    </SearchContextProvider>
  );
};

export default Search;
